import { createStore } from "@xstate/store";

/**
 * Is the full-page `/chat` route the surface currently on screen?
 *
 * Collapsing the gutter panel on entry isn't enough on its own — `Mod+I` or the
 * palette could reopen it a second later, leaving the same conversation
 * rendered twice. `use-agent-ui` reads this to make opening the agent a no-op
 * for as long as the route owns the screen.
 *
 * Deliberately its own module rather than living beside `enterFullPageChat`:
 * that pairing keeps module-scoped state and so gets re-imported fresh in
 * tests, which would give each importer its own copy of this store. Shared
 * state belongs somewhere that is only ever imported once.
 */
export const fullPageChatStore = createStore({
  context: { active: false },
  on: {
    "fullPageChat.enter": () => ({ active: true }),
    "fullPageChat.exit": () => ({ active: false }),
  },
});

export function isFullPageChatActive(): boolean {
  return fullPageChatStore.get().context.active;
}
